<template>
    <div class="quick-locations">
        <div v-if="locations.length === 0" class="quick-locations-empty">
            No locations added yet.
        </div>
        <div v-else class="quick-locations-list">
            <div
                v-for="(loc, index) in locations"
                :key="index"
                class="quick-location-row"
            >
                <div class="location-main">
                    <span class="material-symbols-outlined icon"
                        >location_on</span
                    >
                    <span class="location-name">{{ loc.name }}</span>
                </div>
                <div class="location-date">{{ loc.date }}</div>
                <div class="location-nights">({{ draftNights[index] }})</div>
                <button
                    type="button"
                    class="btn-remove"
                    title="Remove location"
                    @click="removeLocation(index)"
                >
                    <span class="material-symbols-outlined icon">close</span>
                </button>
            </div>
        </div>

        <div class="quick-locations-row">
            <div class="field-geo">
                <label class="quick-field-label">Place</label>
                <GeoSearchInput
                    ref="geoInput"
                    v-model="draft.geo"
                    level="city"
                    placeholder="Search city..."
                    compact
                />
            </div>
            <div class="field-date">
                <label class="quick-field-label">Start date</label>
                <input
                    v-model="draft.date"
                    :min="startDate"
                    :max="endDate"
                    type="date"
                    placeholder="Date"
                    @keydown.enter.prevent="applyLocation"
                />
            </div>
            <div class="field-nights">
                <label class="quick-field-label">Nights</label>
                <input
                    v-model.number="draft.nights"
                    type="number"
                    min="0"
                    :max="maxDraftNights"
                    placeholder="0"
                    @keydown.enter.prevent="applyLocation"
                />
            </div>
            <div class="field-apply">
                <span class="quick-field-label-spacer">&nbsp;</span>
                <Bttn
                    class="outlined slim compact-apply-btn"
                    icon="add"
                    :disabled="!canApply"
                    title="Add location"
                    @click.prevent="applyLocation"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GeoSearchInput from "js/components/forms/GeoSearchInput.vue";

export default {
    name: "QuickLocations",
    components: {
        GeoSearchInput,
    },
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        startDate: {
            type: String,
            required: false,
            default: () => "",
        },
        endDate: {
            type: String,
            required: false,
            default: () => "",
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            locations: [],
            draftNights: [],
            draft: {
                geo: null,
                date: null,
                nights: 0,
            },
        };
    },
    computed: {
        canApply() {
            return (
                !!this.draft.geo &&
                !!this.draft.date &&
                this.draft.nights !== null &&
                this.draft.nights !== "" &&
                !isNaN(this.draft.nights) &&
                Number(this.draft.nights) >= 0
            );
        },
        maxDraftNights() {
            if (!!this.draft.date && !!this.endDate) {
                return this.getDays(this.draft.date, this.endDate);
            }
            return null;
        },
    },
    methods: {
        applyLocation() {
            if (!this.canApply) {
                return;
            }

            const geo = this.draft.geo;
            const name = geo.name || geo.city || geo.ui_name || "";

            const newLocation = {
                name,
                geo,
                date: this.draft.date,
                nights: Number(this.draft.nights),
            };

            this.locations.push(newLocation);
            this.draftNights.push(
                newLocation.nights == 0
                    ? "day trip"
                    : `${newLocation.nights} nights`
            );
            this.$emit("update:modelValue", [...this.locations]);

            const nextDate = new Date(newLocation.date);
            nextDate.setDate(nextDate.getDate() + newLocation.nights);
            this.draft = {
                geo: null,
                date: nextDate.toISOString().split("T")[0],
                nights: 0,
            };

            if (this.$refs.geoInput) {
                this.$refs.geoInput.clear();
            }
        },
        removeLocation(index) {
            this.locations.splice(index, 1);
            this.$emit("update:modelValue", [...this.locations]);
        },
        getDays(startDate, endDate) {
            return (
                (new Date(endDate) - new Date(startDate)) /
                (1000 * 60 * 60 * 24)
            );
        },
    },
};
</script>
